import React from 'react';

interface PCFFooterBackButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

const PCFFooterBackButton: React.FC<PCFFooterBackButtonProps> = ({
  onClick,
  disabled = false,
  label = 'Back'
}) => {
  const handleClick = (): void => {
    if (disabled) {
      return;
    }

    onClick();
  };

  return (
    <button
      type="button"
      className="btn-back"
      onClick={handleClick}
      disabled={disabled}
      aria-disabled={disabled}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path
          d="M19 12H5M5 12L12 19M5 12L12 5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{label}</span>
    </button>
  );
};

export default PCFFooterBackButton;
